<div
  class="[&>brn-select>div>hlm-select-trigger>button]:bg-grey-2 rounded-md [&>brn-select>div]:h-full [&>brn-select>div>hlm-select-trigger]:h-full [&>brn-select>div>hlm-select-trigger>button]:!h-full [&>brn-select>div>hlm-select-trigger>button]:rounded-l-none"
  hlmButtonGroup
>
  <hlm-input-group class="border-grey-3 text-grey-7">
    <input [(ngModel)]="nom" [placeholder]="placeholder()" type="text" hlmInputGroupInput />
    @if (nom()) {
      <hlm-input-group-addon align="inline-end">
        <ng-icon class="mr-xs cursor-pointer" (click)="clearName()" hlm name="lucideX" />
      </hlm-input-group-addon>
    }
    <hlm-input-group-addon align="inline-end">
      <ng-icon hlm name="lucideSearch" />
    </hlm-input-group-addon>
  </hlm-input-group>
  <brn-select class="inline-block" [value]="niveau()" (valueChange)="setLevel($any($event))">
    <hlm-select-trigger class="border-grey-3 text-grey-10 gap-xs flex items-center">
      <hlm-select-value>
        <div *brnSelectValue="let value">
          <span>{{ value ? 'Niveau ' + value : 'Tous les niveaux' }}</span>
        </div>
      </hlm-select-value>
    </hlm-select-trigger>
    <hlm-select-content class="!min-w-40">
      <hlm-option [value]="undefined">
        <span>Tous les niveaux</span>
      </hlm-option>
      @for (item of [3, 4, 5, 6, 7, 8]; track $index) {
        <hlm-option [value]="item">
          <span>Niveau {{ item }}</span>
        </hlm-option>
      }
    </hlm-select-content>
  </brn-select>
</div>
